<template>
  <div class="photo-album-advanced-alternative lazyload">
    <carousel
      :swipe-on-desktop="swipeOnDesktop"
      :speed="600"
      :vertical="!smallScreen"
      :navigation-enabled="!smallScreen"
      :pagination-enabled="smallScreen"
      :per-page="1"
      :carousel-identifier="contentIdentifier"
      class="photo-album-advanced-alternative__content-carousel"
    >
      <slide v-if="slotContentOneExists" class="photo-album-advanced-alternative__content-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="content1"></slot>
        </div>
      </slide>
      <slide v-if="slotContentTwoExists" class="photo-album-advanced-alternative__content-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="content2"></slot>
        </div>
      </slide>
      <slide v-if="slotContentThreeExists" class="photo-album-advanced-alternative__content-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="content3"></slot>
        </div>
      </slide>
    </carousel>
    <carousel
      :swipe-on-desktop="swipeOnDesktop"
      :speed="600"
      :per-page="1"
      :pagination-enabled="!smallScreen"
      :carousel-identifier="mediaIdentifier"
      class="photo-album-advanced-alternative__media-carousel"
    >
      <slide v-if="slotMediaOneExists" class="photo-album-advanced-alternative__media-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="media1"></slot>
        </div>
      </slide>
      <slide v-if="slotMediaTwoExists" class="photo-album-advanced-alternative__media-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="media2"></slot>
        </div>
      </slide>
      <slide v-if="slotMediaThreeExists" class="photo-album-advanced-alternative__media-slide">
        <div class="photo-album-advanced-alternative__slide-inner">
          <slot name="media3"></slot>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {
  name: 'photo-album-advanced-alternative',
  props: {
    tagging: { type: Object, required: true },
    actions: { type: Object, required: true },
    labels: { type: Object, required: true },
    swipeOnDesktop: { type: Boolean, default: true, required: false },
  },
  data() {
    return {
      contentIdentifier: `photo-album--content-${Date.now()}`,
      mediaIdentifier: `photo-album--media-${Date.now()}`,
      state: '',
      smallScreen: window.matchMedia('(max-width: 767px)').matches,
    };
  },
  computed: {
    slotMediaOneExists() {
      return !!this.$slots.media1;
    },
    slotMediaTwoExists() {
      return !!this.$slots.media2;
    },
    slotMediaThreeExists() {
      return !!this.$slots.media3;
    },
    slotContentOneExists() {
      return !!this.$slots.content1;
    },
    slotContentTwoExists() {
      return !!this.$slots.content2;
    },
    slotContentThreeExists() {
      return !!this.$slots.content3;
    },
  },
  mounted() {
    if (!window.eventBus) {
      return;
    }

    window.eventBus.$on('mediaquery.changed', () => {
      this.smallScreen = window.matchMedia('(max-width: 767px)').matches;
    });

    this.bindPageChange();
  },
  methods: {
    onContentPageChange(currentSlide, prevSlide, from) {
      if (!window.eventBus) {
        return;
      }

      this.fireAnalytics(currentSlide, prevSlide, from);

      this.unbindPageChange();
      window.eventBus.$emit(`${this.mediaIdentifier}-gotoPage`, currentSlide);
      this.bindPageChange();
    },

    /* instanbul ignore next */
    onMediaPageChange(currentSlide, prevSlide, from) {
      if (!window.eventBus) {
        return;
      }

      this.fireAnalytics(currentSlide, prevSlide, from);

      this.unbindPageChange();
      window.eventBus.$emit(`${this.contentIdentifier}-gotoPage`, currentSlide);
      this.bindPageChange();
    },

    bindPageChange() {
      if (!window.eventBus) {
        return;
      }

      window.eventBus.$on(`${this.contentIdentifier}-pageChange`, this.onContentPageChange);
      window.eventBus.$on(`${this.mediaIdentifier}-pageChange`, this.onMediaPageChange);
    },

    unbindPageChange() {
      if (!window.eventBus) {
        return;
      }

      window.eventBus.$off(`${this.contentIdentifier}-pageChange`, this.onContentPageChange);
      window.eventBus.$off(`${this.mediaIdentifier}-pageChange`, this.onMediaPageChange);
    },

    fireAnalytics(currentSlide, prevSlide, from) {
      if (from === 'pagination') {
        this.state = this.actions.select;
      }

      if (currentSlide - prevSlide === -1 && (!from || from === 'navigation')) {
        this.state = this.actions.previous;
      } else if (currentSlide - prevSlide === 1 && (!from || from === 'navigation')) {
        this.state = this.actions.next;
      }

      this.label = this.getEventLabel(currentSlide);
    },

    getEventLabel(currentSlide) {
      return this.labels[currentSlide];
    },
  },
};
</script>
